import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isEmpty, toPlainObject } from 'lodash';

import { lockEbons } from '../../../services/ebon/actions';

import { storeLastUserInfo } from '../../../utils/storageUtils';

import AddressForm from './AddressForm';

import './FunnelAddressStepStyle.scss';

const FunnelAddressStep = ({
    partnerId,
    setUserInfo,
    merchantCardPath,
    i18n,
    ebon,
    form,
    lockEbons,
    lockFetching,
    lockFailure,
    createOrderRequest,
    user
}) => {
    const [cappingError, setCappingError] = useState(false);

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    const isFetching = lockFetching || createOrderRequest;

    const FORM_NAME = 'ebonbilling-form';

    // Do lock
    const handleSubmit = async () => {
        const formData = form[FORM_NAME].values;

        let number = null;

        const tempUserInfo = {
            lastname: formData.lastname,
            firstname: formData.firstname,
            billingAdressLine1: formData.address,
            billingAdressLine2: formData.address,
            billingAdress: formData.address,
            billingCity: formData.city,
            billingPostalCode: formData.zipcode,
            billingCountry: 'FR',
            phoneNumber: number,
            saveAddress: false
        };

        const ebonCart = {
            lockRequests: ebon.cart,
            userId: user.username,
            partnerId: partnerId,
            fixedFacialValue: !hasFreeFacial
        };

        storeLastUserInfo(formData.firstname, formData.lastname, number);
        setUserInfo(tempUserInfo);

        lockEbons(ebonCart, number);
    };

    // Handle lock failure
    useEffect(() => {
        if (!isEmpty(lockFailure)) {
            // Check user capping
            if (lockFailure.statusCode === 406) {
                setCappingError(true);
            }
        }
    }, [lockFailure]);

    return (
        <div id="funnel-address-container">
            <h3>{i18n.BILLING_ADDRESS}</h3>
            <AddressForm
                formName={FORM_NAME}
                cappingError={cappingError}
                isFetching={isFetching}
                handleSubmit={handleSubmit}
                merchantCardPath={merchantCardPath}
            />
        </div>
    );
};

FunnelAddressStep.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    setUserInfo: PropTypes.func,
    merchantCardPath: PropTypes.string
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.page.EBON,
        ebon: state.ebon,
        form: state.form,
        lock: state.ebon.lock,
        lockFetching: state.ebon.lockFetching,
        lockFailure: state.ebon.lockFailure,
        createOrderRequest: state.ebon.createOrderRequest,
        user: user
    };
};

const mapDispatchToProps = {
    lockEbons
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FunnelAddressStep));



// WEBPACK FOOTER //
// ./src/components/funnel/address-step/FunnelAddressStep.js